export const iconFontAwesomeShapesSquare = (
	<i className="fa-solid fa-square"></i>
);
